import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from "recharts";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { deviceData } from "../data";

const colors = ["#4680ff", "#13c2c2", "#ffb800"];

export function DeviceBreakdown() {
  const { tick } = useChartTheme();
  const { t } = useTranslation();

  const translatedData = deviceData.map((d) => ({
    ...d,
    label: t.common.devices[d.device] ?? d.device,
  }));

  return (
    <DashboardCard title={t.analytics.deviceBreakdown} className="col-span-full md:col-span-2">
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={translatedData} layout="vertical" margin={{ left: 20 }}>
          <XAxis type="number" hide />
          <YAxis type="category" dataKey="label" axisLine={false} tickLine={false} tick={{ fill: tick, fontSize: 12 }} width={70} />
          <Bar dataKey="value" radius={[0, 6, 6, 0]} maxBarSize={24}>
            {translatedData.map((_, i) => (
              <Cell key={i} fill={colors[i]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
